import pricingPlanService from './ws';

export default pricingPlanService;